import React from 'react';
import { Link } from 'react-router-dom';
import { Users, BarChart3, CreditCard, Share2, CheckCircle, Zap } from 'lucide-react';
import Navbar from '../components/Navbar';

const LandingPage = () => {
  return (
    <div className="page-wrapper">
      <Navbar />

      {/* Hero */}
      <section style={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '60px 20px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Background Glow */}
        <div style={{
          position: 'absolute', inset: 0, zIndex: 0,
          background: 'radial-gradient(ellipse 80% 60% at 50% 30%, rgba(99,102,241,0.15) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} />
        <div style={{
          position: 'absolute', bottom: 0, left: '10%',
          width: '300px', height: '300px',
          background: 'radial-gradient(circle, rgba(6,182,212,0.1) 0%, transparent 70%)',
          pointerEvents: 'none'
        }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '700px' }}>
          <div className="badge badge-primary" style={{ marginBottom: '20px', fontSize: '0.85rem', padding: '6px 16px' }}>
            🎉 نظّم أحداثك بسهولة
          </div>

          <h1 style={{
            fontSize: 'clamp(2.5rem, 6vw, 4rem)',
            fontWeight: 900,
            lineHeight: 1.2,
            marginBottom: '20px',
            background: 'linear-gradient(135deg, #f1f5f9 30%, #6366f1 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>
            ظبطت 🎉
          </h1>

          <p style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
            color: 'var(--text-secondary)',
            marginBottom: '16px',
            lineHeight: 1.7,
          }}>
            المنصة الأسهل لتنظيم خروجات وأحداث مع أصحابك.
            استطلاعات، مدفوعات، وكل تفصيلة في مكان واحد!
          </p>

          <p style={{ color: 'var(--text-muted)', marginBottom: '36px', fontSize: '0.95rem' }}>
            شاليه، رحلة، عزومة؟ — خلّي ظبطت تديرها عنك 🚀
          </p>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-primary btn-lg">
              <Zap size={18} />
              ابدأ مجاناً
            </Link>
            <Link to="/login" className="btn btn-secondary btn-lg">
              دخول
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '80px 20px', background: 'var(--bg-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '12px' }}>
              كل اللي تحتاجه في مكان واحد
            </h2>
            <p style={{ color: 'var(--text-secondary)' }}>من الدعوة لأصحابك لحد تأكيد الدفع</p>
          </div>

          <div className="grid-3" style={{ gap: '20px' }}>
            {features.map((f, i) => (
              <FeatureCard key={i} {...f} delay={i * 100} />
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section style={{ padding: '80px 20px' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '12px' }}>
              إزاي بيشتغل؟
            </h2>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '600px', margin: '0 auto' }}>
            {steps.map((s, i) => (
              <div key={i} className="card" style={{
                display: 'flex', alignItems: 'flex-start', gap: '16px',
                padding: '20px 24px',
                borderRight: '3px solid var(--primary)',
                animation: `slideIn 0.4s ease ${i * 100}ms both`
              }}>
                <div style={{
                  width: '36px', height: '36px', borderRadius: '50%',
                  background: 'var(--gradient-primary)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 800, fontSize: '1rem', flexShrink: 0, color: 'white'
                }}>
                  {i + 1}
                </div>
                <div>
                  <h3 style={{ marginBottom: '6px', fontSize: '1rem' }}>{s.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, rgba(99,102,241,0.1) 0%, rgba(6,182,212,0.05) 100%)',
        borderTop: '1px solid var(--border)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '16px' }}>
            جاهز تظبط أول حدث؟ 🎉
          </h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
            مجاني 100% — ابدأ دلوقتي
          </p>
          <Link to="/register" className="btn btn-primary btn-lg">
            إنشاء حساب مجاني
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '24px',
        borderTop: '1px solid var(--border)',
        textAlign: 'center',
        color: 'var(--text-muted)',
        fontSize: '0.85rem'
      }}>
        ظبطت 🎉 — جميع الحقوق محفوظة {new Date().getFullYear()}
      </footer>
    </div>
  );
};

const FeatureCard = ({ icon, title, desc, delay }) => (
  <div className="card card-hover" style={{
    textAlign: 'center', padding: '28px 20px',
    animation: `slideUp 0.4s ease ${delay}ms both`
  }}>
    <div style={{
      width: '56px', height: '56px', borderRadius: '16px',
      background: 'rgba(99,102,241,0.15)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      margin: '0 auto 16px', color: 'var(--primary-light)', fontSize: '1.5rem'
    }}>
      {icon}
    </div>
    <h3 style={{ fontSize: '1rem', marginBottom: '8px' }}>{title}</h3>
    <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', lineHeight: 1.6 }}>{desc}</p>
  </div>
);

const features = [
  { icon: <Users size={24} />, title: 'إنشاء جروبات', desc: 'أنشئ مجموعة وادعو أصحابك برابط خاص في ثوانٍ' },
  { icon: <BarChart3 size={24} />, title: 'استطلاعات ذكية', desc: 'نوعين: استطلاع عادي لمعرفة الأعداد، أو مالي لتحديد التكلفة' },
  { icon: <CreditCard size={24} />, title: 'متابعة الدفع', desc: 'كل عضو يرفع إيصاله والأدمن يأكد — ما فيش حاجة تتنسى' },
  { icon: <Share2 size={24} />, title: 'روابط دعوة', desc: 'شارك الرابط مع أصحابك وهما يدخلوا بضغطة واحدة' },
  { icon: <CheckCircle size={24} />, title: 'تتبع كامل', desc: 'شوف مين دفع ومين لسه — كل حاجة واضحة قدامك' },
  { icon: <Zap size={24} />, title: 'سريع وسهل', desc: 'واجهة بسيطة ومريحة، مفيش تعقيد أو حيرة' },
];

const steps = [
  { title: 'الأدمن ينشئ المجموعة', desc: 'يضع اسم المجموعة، صورتها، وعدد الأعضاء الأقصى' },
  { title: 'يشارك رابط الدعوة', desc: 'الأعضاء يدخلوا الرابط ويسجلوا أو يدخلوا بحسابهم' },
  { title: 'الأدمن يضيف بوستات واستطلاعات', desc: 'يتضمن الاستطلاعات التقليدية والمالية مع المواعيد' },
  { title: 'الأعضاء يتفاعلوا ويدفعوا', desc: 'يختاروا في الاستطلاع ويرفعوا صورة الإيصال' },
  { title: 'الأدمن يأكد ويتابع', desc: 'يشوف مين دفع ومين لأ ويأكد من بروفايل كل عضو' },
];

export default LandingPage;
